//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { SCHEDULE_ITEM_TASK_NAME } from '@instagram-account/redux/account/instagramAccountModel';

export const requiredPermissions = [
  'user.info.basic',
  'user.insights',
  'video.list',
  'video.insights',
  'video.publish',
];

// TODO: PD-285704: Remove this once tiktok mentions ingestion feature flag is released
export const getRequiredPermissions = (
  getIsTikTokMentionsFeatureEnabled: boolean,
) => {
  return getIsTikTokMentionsFeatureEnabled
    ? [...requiredPermissions, 'biz.brand.insights']
    : requiredPermissions;
};

/* Intentionally using the same permission as instagram scheduling */
export const TIKTOK_SCHEDULE_ITEM_TASK_NAME = SCHEDULE_ITEM_TASK_NAME;

export const ABBREVIATE_NUMERIC_METRICS_LIMIT = 1000000;

export const MEDIA_CARD_DATE_FORMAT = 'MMM D, YYYY, h:mm A z';
